<template>
  <div class="relative">
    <span v-if="modelValue == ''" class="custom-placeholder">
      {{ placeholder }}
    </span>
    <input
      :id="inputId"
      type="text"
      class="search-input w-full h-[42px] p-2.5 pr-[40px] text-sm font-normal border text-primary-dark bg-white border-grey-light rounded-md focus:outline-none focus:border-[#1F1D1F]"
      :value="modelValue"
      @input="updateValue($event.target.value)"
      @keydown.enter="search()"
    />

    <SearchIcon
      v-if="modelValue == ''"
      class="searchIcon absolute text-[#555055] -translate-y-1/2 right-[10px] top-1/2"
    />

    <svg
      v-if="modelValue"
      @click="emit('update:modelValue', '')"
      class="absolute text-primary-dark -translate-y-1/2 right-[10px] top-1/2 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6 6l8 8M14 6l-8 8"
        stroke="#555055"
        stroke-width="1.8"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<script setup>
const props = defineProps({
  inputId: {
    type: String,
    default: "searchInput",
  },
  // ข้อความที่ยาวจะถูกตัดด้วย Ellipsis
  placeholder: {
    type: String,
    default:
      "ค้นหา ชื่อทีมแพทย์, ชื่อหัวหน้าทีม, ชื่อสถานที่, ข้อมูลอื่น ๆ ที่อาจจะยาวมาก",
  },
  modelValue: {
    type: [String, Number],
    default: "",
  },
});

const emit = defineEmits(["update:modelValue", "search"]);

const updateValue = (value) => {
  emit("update:modelValue", value);
};

const search = () => {
  emit("search");
};
</script>

<style scoped lang="scss">
.searchIcon {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 2px 2px 1.999px 2px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
}
/*
 * SCSS/CSS สำหรับ Placeholder จำลอง
 * กำหนดให้มีการตัดข้อความด้วยจุดไข่ปลา
 */
.custom-placeholder {
  /* ตำแหน่งที่ทับ input */
  position: absolute;
  top: 50%;
  left: 10px; /* ตรงกับ p-2.5 ของ input */
  transform: translateY(-50%);

  /* สไตล์ตัวอักษร */
  color: #b7b2b5;

  /* fields/label L */
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  letter-spacing: 0.1px;

  /* สำคัญ: ทำให้คลิกทะลุ span เพื่อไปโฟกัส input ได้ */
  pointer-events: none;

  /* *** CSS ที่ทำให้เกิดจุดไข่ปลา (Ellipsis) *** */
  /* * คำนวณความกว้าง: 
     * 100% (ความกว้างทั้งหมด) 
     * ลบด้วย (padding-right 40px จาก pr-[40px] ที่เผื่อ Search/Clear Icon)
     * ลบด้วย (padding-left 10px จาก p-2.5) 
     */
  width: calc(100% - 40px - 10px);
  overflow: hidden;
  white-space: nowrap; /* ห้ามขึ้นบรรทัดใหม่ */
  text-overflow: ellipsis; /* แสดงจุดไข่ปลา */
}
</style>